import React, { useState, useEffect, useRef } from "react";
// 第三方
import { NavLink } from "react-router-dom";
import ScrollBar from "@/components/ScrollBar/ScrollBar.jsx";
// 我的
import UserAvatar from "@/components/UserAvatar/index.jsx";
// # 动画
import { motion } from "framer-motion";
import MotionScale from "@/components/FramerMotion/MotionScale";
// # redux
import { useSelector, useDispatch } from "react-redux";
import { change } from "@/plugin/slice/elementStateSlice.js";
// # CSS
import "./style.css";
// 图标
import {
  IconArticle,
  IconMore,
  IconMusicList,
  SiteLogo,
  IconUser,
} from "@/components/Icon/index.jsx";
//
import { Menu } from "antd";
import { ConfigProvider } from "antd";
// 下拉时改变字体颜色的动画组件
// 动画变化的初始背景颜色 样式
const initialBackgroundColor = {
  color: "black",
};

// 动画变化的最终背景颜色 样式
const finalBackgroundColor = {
  color: "white",
};
function ChangeFontColor(props) {
  // console.log(1000, props);
  const { isScrolled } = props;
  return (
    <motion.div
      initial={initialBackgroundColor} // 初始状态为透明
      // animate={isScrolled ? { color: "white" } : { color: 'black' }}
      animate={isScrolled ? finalBackgroundColor : initialBackgroundColor}
    >
      {props.children}
    </motion.div>
  );
}
///////////
const NavbarAntd = () => {
  // 获取登录状态
  const loginState = useSelector((state) => state.loginState.loginState);

  // 在不是最顶部时，导航栏背景不透明，在顶部状态为false
  const [isScrolled, setIsScrolled] = useState(false);
  const items = [
    {
      label: (
        <MotionScale>
          <NavLink to={"/"}>
            <SiteLogo />
          </NavLink>
        </MotionScale>
      ),
      key: "home",
    },
    loginState
      ? {
          label: (
            <div>
              <MotionScale>
                <UserAvatar />
              </MotionScale>
            </div>
          ),
          key: "avatar",
          popupClassName: "useravatar",
        }
      : NaN,
    {
      label: (
        <ChangeFontColor isScrolled={isScrolled}>
          <MotionScale>
            <NavLink to="/article">
              <IconArticle />
              Article
            </NavLink>
          </MotionScale>
        </ChangeFontColor>
      ),
      key: "article",
      // disabled: true,
    },
    {
      label: (
        <ChangeFontColor isScrolled={isScrolled}>
          <MotionScale>
            <NavLink to="/ipfs">
              <IconArticle />
              IPFS
            </NavLink>
          </MotionScale>
        </ChangeFontColor>
      ),
      key: "ipfs",
      // disabled: true,
    },
    loginState
      ? {
          label: (
            <ChangeFontColor isScrolled={isScrolled}>
              <MotionScale>
                <NavLink to="/music">
                  <IconMusicList />
                  Music
                </NavLink>
              </MotionScale>
            </ChangeFontColor>
          ),
          key: "music",
          // disabled: true,
        }
      : NaN,
    // 菜单; 更多
    // {
    //   label: (123),
    //   key: 'login'
    // },
    {
      label: (
        <MotionScale>
          <IconMore />
        </MotionScale>
      ),
      key: "SubMenu",
      children: [
        loginState ? NaN :
        {
          label: (
            <NavLink to={"login"}>
              <IconUser /> Login
            </NavLink>
          ),
          key: "login",
        },
        {
          label: "undetermined",
          key: "un",
        },
      ],
    },
    // 链接
    // {
    //   label: (
    //     <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
    //       Navigation Four - Link
    //     </a>
    //   ),
    //   key: "alipay",
    // },
  ];
  //
  const dispatch = useDispatch();
  //// 获取导航栏高度，并设置(共享)给redux中的状态
  const elementRef = useRef(null);

  useEffect(() => {
    if (elementRef.current && elementRef.current.offsetHeight) {
      const height = elementRef.current.offsetHeight;
      // console.log(6000, "元素的高度:", height);
      dispatch(change(height));
    }
  }, [elementRef, dispatch]);
  //
  const [current, setCurrent] = useState("mail");
  const onClick = (e) => {
    // console.log("click ", e);
    setCurrent(e.key);
  };
  // # 动画
  // 动画变化的初始背景颜色 样式
  const initialBackgroundColor = {
    backgroundColor: "rgba(0,0,0,0)",
  };

  // 动画变化的最终背景颜色 样式
  const finalBackgroundColor = {
    backgroundColor: "#00000050",
    backdropFilter: "blur(10px)",
  };
  //
  // console.log(isScrolled);
  //
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    // console.log(1000, isScrolled);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);
  //
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            // itemBg: isScrolled ? '#f0fbf3' :'rgba(0, 0, 0, 0)',  // 导航栏背景色
            itemBg: "rgba(0, 0, 0, 0)", // 导航栏背景色
            // activeBarHeight: 2, // 下边框激活条
            // itemColor: '#002000'     // 导航栏字体颜色
            itemBorderRadius: 8,
            itemHoverBg: "rgba(0, 0, 0, 0.06)",
            subMenuItemBorderRadius: 8, // 子菜单 选中圆角
          },
          Dropdown: {
            borderRadiusOuter: 4,
            controlItemBgActive: "rgba(0, 0, 0, 0)",
            controlItemBgHover: "rgba(0, 0, 0, 0)",
          },
        },
      }}
    >
      <motion.div
        ref={elementRef}
        className="sticky-top "
        initial={initialBackgroundColor} // 初始状态为透明
        animate={
          isScrolled ? finalBackgroundColor : initialBackgroundColor // 判断如果不在顶部，则变不透明
        }
        transition={{ duration: 0.8 }} // 动画持续时间为1秒
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1, duration: 1 }} // 动画持续时间为1秒
        >
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={items}
            style={{
              borderBottom: "none", // 自带样式的下边框去除
              // background: 'blue'
            }}
          />
          <ScrollBar />
        </motion.div>
      </motion.div>
    </ConfigProvider>
  );
};
export default NavbarAntd;
